import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TimeKeeperDashboardService {
  private readonly getChartsDataByIdUrl =environment.main_url + environment.chartDataByIdUrl

  constructor(private readonly http: HttpClient) { }

 
}
